export default "__VITE_ASSET__CVD7j7_O__"